import { IndividualComponentModel } from './individual-component-model';

export class IndividualComponentViewModel extends IndividualComponentModel{
    husbandMarriageAge: string;
    wifeMarriageAge: string;
}